import resume from "./pdf/resume.pdf"

export const headerData = {
    
    resumePdf: resume
}
